<template>
  <GrupoLeyendaCheck titulo="Hidrografía" v-model="hidrografia_expanded">
    <!-- <BotonQuitarTodos @click="quitarTodos" v-width-control="'30%'" /> -->
    <span v-width-control="'40%'"></span>
    <BotonMasInfo @click="masInfo" v-width-control="'45%'" />
    <DaiLeyendaMapa
      :para="[
        'corrientes_de_agua_continuas',
        'corrientes_de_agua_intermitentes',
        'corrientes_de_agua_canales',
      ]"
      titulo="Corrientes"
      v-width-control="'100%'"
      :mostrar-boton-alterna-todos="true"
      estilo-boton-alterna-todos="checkbox"
      :colapsable="true"
    />
    <hr class="dai-map-separator thin" />
    <DaiLeyendaMapa
      :para="['cuerpos_de_agua_perenne', 'cuerpos_de_agua_intermitente']"
      titulo="Cuerpos de agua"
      v-width-control="'100%'"
      :mostrar-boton-alterna-todos="true"
      estilo-boton-alterna-todos="checkbox"
      :colapsable="true"
    />
  </GrupoLeyendaCheck>
</template>

<script>
import GrupoLeyendaCheck from "./utils/GrupoLeyendaCheck.vue";
import BotonMasInfo from "./utils/BotonMasInfo.vue";
// import BotonQuitarTodos from "./utils/BotonQuitarTodos.vue";
import { scrollToFichas } from '@/components/_utils.js'

export default {
  components: {
    GrupoLeyendaCheck,
    // BotonQuitarTodos,
    BotonMasInfo,
  },
  computed: {
    hidrografia_expanded: {
      get() {
        return this.$store.state.mapa.temasExpandidos.hidrografia;
      },
      set(expandido) {
        this.$store.commit("mapa/setTemasExpandidos", {
          tema: "hidrografia",
          expandido: expandido,
        });
      },
    },
  },
  methods: {
    quitarTodos() {
      console.log("apagar todas las capas de hidrologia");
    },
    masInfo() {
      scrollToFichas(this.$el)
      this.$store.commit("mapa/setFichaActiva", "hidrografia");
    },
  },
};
</script>